
    <mat-slide-toggle (change)="checkedHandler($event)" [checked]="params.value"></mat-slide-toggle>
  